import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Skeleton from "react-loading-skeleton";
import { PodcastSkeleton, PodcastsList as StyledPodcastsList } from "./styled";

import Slider from "react-slick";
import { NextArrow } from "./Arrows/NextArrow";
import { PrevArrow } from "./Arrows/PrevArrow";
import PodcastCardSlider from "./PodcastCardSlider";

export const PodcastsListSlider = ({ podcasts, isLoading, showProgress }) => {
  const settings = {
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 300,
    arrows: true,
    swipe: true,
    swipeToSlide: true,

    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,

    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 595,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  if (isLoading) {
    return (
      <StyledPodcastsList>
        {Array.from({ length: 4 }).map((_, index) => (
          <PodcastSkeleton as={Skeleton} key={index} />
        ))}
      </StyledPodcastsList>
    );
  }

  return (
    <StyledPodcastsList>
      <div className="slider-container">
        <Slider {...settings}>
          {podcasts.map((podcast, index) => (
            <PodcastCardSlider
              key={podcast.id}
              podcast={podcast}
              podcastReleases={podcast.podcastReleases}
              showProgress={showProgress}
              duration={index || 1}
            />
          ))}
        </Slider>
      </div>
    </StyledPodcastsList>
  );
};
